import { useEffect } from 'react';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';
import CTA from '../../home/components/CTA';
import { useSEO, getServiceSchema } from '../../../utils/seo';

export default function SocialMediaPage() {
  useSEO({
    title: 'Social Media Marketing for Contractors | Facebook & Instagram Ads',
    description: 'Strategic social media marketing for contractors. Build brand awareness and generate qualified leads with expert management of organic content and high-converting paid advertisements on Facebook and Instagram.',
    keywords: 'contractor social media marketing, contractor Facebook ads, contractor Instagram marketing, social media for home services',
    canonical: '/services/social-media',
    schema: getServiceSchema(
      'Social Media Marketing for Contractors',
      'Strategic social media campaigns that build brand awareness and generate qualified leads. Expert management of both organic content and high-converting paid advertisements.'
    )
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-red-600/10 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-600 rounded-2xl mb-6">
              <i className="ri-megaphone-line text-4xl text-white"></i>
            </div>
            <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6">
              Social Media Marketing
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Strategic social media campaigns that build brand awareness and generate qualified leads. Expert management of both organic content and high-converting paid advertisements.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={scrollToContact} className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer">
                Get Started <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-image-line', title: 'Content Creation', desc: 'Professional posts that engage your audience' },
              { icon: 'ri-advertisement-line', title: 'Targeted Ads', desc: 'Reach the right customers with precision targeting' },
              { icon: 'ri-chat-3-line', title: 'Engagement', desc: 'Build relationships with your community' },
              { icon: 'ri-line-chart-line', title: 'Analytics', desc: 'Track performance and optimize campaigns' }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-2xl hover:shadow-xl transition-all">
                <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="font-heading text-xl font-bold text-black mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
      <Footer />
    </div>
  );
}
